import React from 'react'
import Thumbnail from '../Thumbnail'
import { EventCard, FlexWrapper,NewChampionsCardNew, NewContentV2New, NewVideoPlayerNew } from '../MainEvents/RecommendEventVideos/styles'
import { RestoreCategoryIcon } from '../../utils/icons'
import { ImageUrl } from '../../utils/constants'
import { fetchApi } from '../../utils/methods'
import { useEffect } from 'react'
import { toast } from 'react-toastify'
import { GetLaunchedArticle, GetLaunchedFitness, GetLaunchedRecipe, RestoreArticles,RestoreRecipes,RestoreFitness } from '../../redux/constants/apiConstants'
import { NoText } from './style'
import { useHistory } from "react-router-dom";
import PropTypes from 'prop-types'
import CommonModalNew from '../common/CommonModal/CommonModalNew'




function ArchivedComponent({type}) {
  const [archiveData, setArchiveData] = React.useState([]);
  const [restorePopupOpen, setRestorePopupOpen] = React.useState(false);
  const [selectedRecipe, setSelectedRecipe] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [page, setPage] = React.useState(1);
  // const [lastPage, setLastPage] = React.useState(null);
  const [hasMore, setHasMore] = React.useState(true);
  const history = useHistory();  

  const API_BY_TYPE = {
    articles: GetLaunchedArticle,
    fitness: GetLaunchedFitness,
    recipes: GetLaunchedRecipe  
  };


  const TYPE_LABEL = {
    articles: "Article",
    recipes: "Recipe",
    fitness: "Video",
  };


  const TYPE_LABEL_SmallCase = {
    articles: "article",
    recipes: "recipe",
    fitness: "video",
  };



  useEffect(() => {
    if (!hasMore || loading) return;
    // if (page === 0) return;
    FetchArchivedData(page);
  }, [page]);

 

  useEffect(() => {
    resetAndLoad();
  }, []);
  
  const resetAndLoad = () => {
    setArchiveData([]);
    setPage(1);
    setHasMore(true);
    FetchArchivedData(1); 
    // setLastPage(null);
  };

  // useEffect(()=>{
  //   setArchiveData([]);
  //   setPage(1);
  //   setHasMore(true);
  //   FetchArchivedData(1);
  // },[])
  


  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + window.scrollY >= document.body.offsetHeight - 200 &&
        hasMore &&
        !loading 
      ) {
        setPage((prev) => prev + 1);
        // FetchArchivedData(page);
      }
    };
  
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [hasMore, loading]);
  


  const handleRestorePopup = (item) => {
    setRestorePopupOpen(true);
    setSelectedRecipe(item);
  }



  const RestoreCatgories = async()=>{
   
    const categoryId = type ==="recipes" ?  selectedRecipe?.recipe_id : type ==="fitness" ?  selectedRecipe?.fitness_id : selectedRecipe?.article_id; 
    let apiUrl = type ==="recipes" ? RestoreRecipes : type ==="fitness" ? RestoreFitness : RestoreArticles;
    try {
      const res = await fetchApi(apiUrl + "/" + categoryId, "POST");
      if(res.status === 'success'){
        toast.success(res.message);
        resetAndLoad();
       
      }else{
        toast.error((res?.message))
      }
    } catch (error) {
      window.console.error(error);
    }
  }

  const handleRestorePopupClose = () => {
    setRestorePopupOpen(false);
  }



  const handleConfirmRestore = () => {
    RestoreCatgories();
    setRestorePopupOpen(false);
  }




  const FetchArchivedData = async(pageNumber = 1)=>{


    if (loading) return;

    setLoading(true);
    const is_archive = 1;
    const limit = 5;
    const order ="desc";
    const apiUrl = API_BY_TYPE[type];
      
    try {
      const url =`${apiUrl}?limit=${limit}&order=${order}&is_archive=${is_archive}&page=${pageNumber}`;
      const res = await fetchApi(url,"GET");
      //   const res = await fetchApi(GetLaunchedArticle + "/" +  is_archive ,"GET");
      if(res.status === 'success'){
        const pageObj = res.data[0];   
        // const pageData = pageObj.data;
        // setArchiveData(res.data[0].data)
        setArchiveData((prev) =>
          pageNumber === 1
            ? pageObj.data
            : [...prev, ...pageObj.data]
        );
  
        // setLastPage(pageObj.last_page);

        if (pageObj.current_page >= pageObj.last_page) {
          setHasMore(false);   // 🔒 STOP forever
        }
        // setArchiveData((prev) =>
        //   pageNumber === 1 ? pageData : [...prev, ...pageData]
        // );
  
        // if (pageObj.current_page >= pageObj.last_page) {
        //   setHasMore(false);
        // } 
      }else{
        toast.error((res?.data?.message))
      }
    } catch (error) {
      window.console.error(error);
    }
    finally {
      setLoading(false);   // ✅ release lock
    }
  }


  const handleCardClick = (item) => {

    if (type === "articles")
      history.push({pathname:`/wellness-resources/article-details/${item.article_id}`,state : {page:"Articles"}});
    else if (type === "fitness")
      history.push({pathname: `/wellness-resources/fitness-details/${item.fitness_id}` ,state : {page:"Fitness"}});
    else if (type === "recipes")
      history.push({pathname:`/wellness-resources/recipe-details/${item.recipe_id}`,state : {page:"Recipes"}});
  };



  return (
    <div>
    
      { archiveData.length ?
    
        <FlexWrapper>
          {archiveData
            .map((item) => (
              <NewChampionsCardNew key={item.article_id}>
                <EventCard isMarginBottom={"0px"} borderRadius={"6px 6px 0 0"} isWidth={"398px"} >
                    
                  <NewVideoPlayerNew onClick={() => handleCardClick(item)}  style={{ cursor: 'pointer' }}>
                    <Thumbnail
                      style={{ cursor: 'pointer',marginTop:"8px"  }} 
                      src={`${ImageUrl}/${item?.article_image || item?.recipe_image || item?.thumbnail_image}`}
                      alt={'img'}
                    />
                  </NewVideoPlayerNew>
                  <NewContentV2New newPadding={'newPadding'} isPadding={"16px 8px 8px 8px"}  style={{ minHeight: 'auto',backgroundColor:"#FEFEFE",borderRadius:'0px 0px 8px 8px' }}>
                    <div className='firstContainer'>
                      <div className='name' title={item?.title}>
                        {item?.title}
                      </div>
                    </div>
                    <div className="imageContainer">
                      <span
                        className="icon archive"
                        onClick={() => handleRestorePopup(item)}
                        title="Archive"
                      >
                        {RestoreCategoryIcon()}
                      </span>
                      
                    </div>
                  </NewContentV2New>
                </EventCard>
              </NewChampionsCardNew>
            ))}
        </FlexWrapper>:
        <NoText>No archived data found.</NoText>}

      {restorePopupOpen && <CommonModalNew
        show={restorePopupOpen}
        icon={RestoreCategoryIcon("#184A61")}
        title={`Restore ${TYPE_LABEL[type]}`}
        description={`Are you sure you want to restore this ${TYPE_LABEL_SmallCase[type]}?`}
        subDescription={`You can view these ${TYPE_LABEL_SmallCase[type]} in the category you have uploaded`}
        onCancel={handleRestorePopupClose}
        onConfirm={handleConfirmRestore}
        cancelText={`Keep ${TYPE_LABEL[type]}`}
        confirmButtonText="Restore"
        buttonIcon={RestoreCategoryIcon("white")}
        modalHeight="261px"
        confirmButtonWidth="200px"
      />}
    </div>
  )
}


ArchivedComponent.propTypes = {
  type: PropTypes.string,
};


export default ArchivedComponent;
